import moment from 'moment'

// ? 檢查 token
const token = {
  getToken: function () {
    const papaTKExpire = localStorage.getItem('papaTKExpire')
    const now = moment().format('YYYY/MM/DD HH:mm:ss')
    if (moment(now, 'YYYY/MM/DD HH:mm:ss').isAfter(papaTKExpire)) {
      // 過期
      localStorage.removeItem('papaTK')
      localStorage.removeItem('papaTKExpire')
      return ''
    } else {
      // 未過期
      return localStorage.getItem('papaTK') || ''
    }
  },
  removeToken: function () {
    localStorage.removeItem('papaTK')
    localStorage.removeItem('papaTKExpire')
  }
}

export default token
